import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { vantLocales } from '@/i18n'

export const useSystemStore = defineStore('counter', () => {
  const loading = ref(false)
  const lang = ref('')
  const params = ref({})
  const isEn = computed(() => lang.value === 'en')
  const isPc = computed(() => {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    console.log(flag,'isPc') 
    return !flag
  })
  function setLoading(value: boolean) {
    loading.value = value
    setTimeout(() => {
      loading.value = false
    }, 2000);
  }
  function setBaseParams(obj:any) {
    params.value = obj
  }
  function setLang(value:string) {
    lang.value = value
    vantLocales(value)
  }

  return { loading, params, isEn, isPc, setLoading, setBaseParams, setLang }
})
